import { LinkGuard } from 'components/RoleGuard';
import { useColumnHeaders } from 'domain/hooks/useApiList';
import { DerivedVariable } from 'domain/models/api.models';
import { AppRoutes } from 'domain/routes';
import { CardListContext } from 'pages/base/CardList';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const DerivedCard = ({ item }: { item: DerivedVariable }) => {
	const { t } = useTranslation(['entities', 'labels']);

	const { rel } = useContext(CardListContext);
	const columns = useColumnHeaders<DerivedVariable>(rel);

	if (!item) {
		return <></>;
	}

	if (!item) {
		return <></>;
	}
	const render = (item: DerivedVariable, key: string) => {
		if (key in item) {
			const text = (item as any)[key];
			return <>{text}</>;
		}
		return <>{t('label:unknown')}</>;
	};

	return (
		<LinkGuard
			role='ROLE_ADMIN'
			to={AppRoutes.EditDerived.replace(':id', '' + item.id)}>
			<div className='flex w-full flex-row justify-between'>
				{columns.map((key, index) => (
					<div className='w-full truncate' key={key}>
						{render(item, key)}
					</div>
				))}
			</div>
		</LinkGuard>
	);
};
